/* The Hollow Harvest · la sala.

   PERCHE' ESISTE. Diego, dal telefono, il 2026-09-10: "e' stra mega lungo".
   Misurato: la pagina era alta 37.774 pixel, cioe' quarantacinque schermate di
   telefono, e piu' della meta' erano gallerie. Venti creature, diciassette
   mappe, dieci libri, sei tavole e sei personaggi, tutti stesi uno sotto
   l'altro. Su un telefono nessuno scorre quarantacinque schermate: si guarda
   la prima, si pensa che non finisca piu', e si chiude.

   COSA FA. Sul telefono la galleria si corica: da colonna che scende per due
   schermate diventa una STRISCIA che si scorre col dito, alta quanto una
   copertina. Sotto, un invito ad aprire tutto. Chi lo apre trova una stanza a
   se': schermo intero, testata col nome e il conto, e dentro la galleria
   intera, in verticale e in grande. Chi non vuole scorre oltre in mezza
   schermata. Sul computer non cambia niente: li' lo spazio c'e' e la pagina
   lunga e' una vetrina, non un muro.

   Perche' una striscia e non una griglia piu' corta: in orizzontale lo spazio
   non costa niente. Dieci copertine in colonna sono duemila pixel da scorrere,
   le stesse dieci in fila sono trecento pixel e un gesto che sul telefono si
   fa senza pensarci.

   COME. Le celle oltre l'anteprima vengono nascoste, quindi le loro immagini
   (che sono pigre) non si scaricano nemmeno: sul telefono si scarica quello
   che si guarda. All'apertura la griglia VIENE SPOSTATA dentro il pannello,
   non clonata: i comandi del sito attaccano i loro ascoltatori agli elementi,
   e un elemento spostato se li porta dietro. Un clone invece sarebbe muto.
   Alla chiusura torna al suo posto, dove il JS ha lasciato un segnaposto.

   SENZA JAVASCRIPT non succede niente di niente: la galleria resta intera e la
   pagina lunga, che e' il comportamento giusto quando non si puo' aprire. */

(function () {
  'use strict';

  var SOGLIA = 900;        /* sopra questa larghezza la sala non serve */
  var gallerie = [];
  var pannello = null;
  var corpo = null;
  var titolo = null;
  var conto = null;
  var aperta = null;       /* la galleria aperta adesso */
  var fuocoPrima = null;
  var scrollPrima = 0;

  function testo(el, attr, difetto) {
    var v = el.getAttribute(attr);
    return v && v.trim() ? v.trim() : difetto;
  }

  /* ---------- il pannello, uno solo per tutta la pagina ---------- */
  function creaPannello() {
    if (pannello) return;
    pannello = document.createElement('div');
    pannello.className = 'hh-hall';
    pannello.setAttribute('role', 'dialog');
    pannello.setAttribute('aria-modal', 'true');
    pannello.tabIndex = -1;   /* il fuoco entra QUI, non sul bottone di chiusura */
    pannello.hidden = true;
    pannello.innerHTML =
      '<div class="hh-hall__bar">' +
        '<div class="hh-hall__id">' +
          '<p class="hh-hall__title"></p>' +
          '<p class="hh-hall__count"></p>' +
        '</div>' +
        '<button type="button" class="hh-hall__close" aria-label="Close">&#215;</button>' +
      '</div>' +
      '<div class="hh-hall__body"></div>';
    document.body.appendChild(pannello);
    corpo = pannello.querySelector('.hh-hall__body');
    titolo = pannello.querySelector('.hh-hall__title');
    conto = pannello.querySelector('.hh-hall__count');
    pannello.querySelector('.hh-hall__close').addEventListener('click', function () { chiudi(true); });
  }

  /* ---------- c'e' una foto aperta sopra la sala? ---------- */
  function fotoAperta() {
    var l = document.querySelector('.hh-lightbox.is-open, .hh-flip.is-open');
    return l && !l.hidden ? l : null;
  }
  function chiudiFoto(l) {
    var b = l.querySelector('.hh-lightbox__close, .hh-flip__close');
    if (b) b.click();
  }

  /* ---------- apri e chiudi ---------- */
  function apri(g) {
    if (aperta) return;
    creaPannello();
    aperta = g;
    fuocoPrima = document.activeElement;
    scrollPrima = window.pageYOffset;

    g.celle.forEach(function (c) { c.classList.remove('is-hall-hidden'); });
    g.griglia.classList.remove('hh-hall-strip');   /* dentro la stanza si sta in verticale */
    /* le comparse: dentro la sala si entra gia' rivelati, altrimenti chi apre
       vede una stanza vuota che si riempie mentre scorre */
    g.griglia.querySelectorAll('.hh-reveal').forEach(function (r) { r.classList.add('is-in'); });

    if (g.tema) pannello.setAttribute('data-theme', g.tema);
    else pannello.removeAttribute('data-theme');
    titolo.textContent = g.nome;
    conto.textContent = g.conto;
    corpo.appendChild(g.griglia);
    g.griglia.classList.add('is-in-hall');

    pannello.hidden = false;
    document.body.classList.add('hh-hall-open');
    /* due fotogrammi: il primo mette il pannello nel documento, il secondo lo
       accende. Con uno solo la comparsa non parte e si vede uno scatto. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        /* IL CONTROLLO CHE MANCAVA. Fra il momento in cui si chiede il
           fotogramma e il momento in cui arriva puo' essere successo di tutto,
           e su WebKit quei due fotogrammi arrivano anche molto tardi: se nel
           frattempo la sala e' stata chiusa, questa riga la riaccendeva da
           sola. Il pannello restava sopra la pagina e nessun altro invito era
           piu' toccabile. Misurato il 2026-09-13: una sala su cinque. */
        if (aperta) pannello.classList.add('is-open');
      });
    });
    corpo.scrollTop = 0;
    /* Il fuoco va sul pannello, non sul bottone che chiude: mettendolo sul
       bottone, chi apre col dito si trova l'anello del fuoco acceso addosso
       alla X, che sembra un difetto. Sul pannello il fuoco entra lo stesso
       (chi usa la tastiera trova la X al primo Tab) ma non si vede niente. */
    pannello.focus({ preventScroll: true });
    g.bottone.setAttribute('aria-expanded', 'true');

    try { history.pushState({ hh_hall: 1 }, ''); } catch (e) { /* niente storia, niente tasto indietro */ }
  }

  function chiudi(gestisciStoria) {
    if (!aperta) {
      /* Rete di sicurezza. Se il pannello e' rimasto visibile senza nessuna
         sala aperta, va spento comunque: coprirebbe la pagina e nessun invito
         sarebbe piu' toccabile. Succede su WebKit quando la cronologia
         risponde in ritardo: misurato una volta su cinque il 2026-09-13. */
      if (pannello && !pannello.hidden) {
        pannello.classList.remove('is-open');
        pannello.hidden = true;
        document.body.classList.remove('hh-hall-open');
      }
      return;
    }
    var g = aperta;
    aperta = null;

    g.griglia.classList.remove('is-in-hall');
    g.segnaposto.parentNode.insertBefore(g.griglia, g.segnaposto);
    if (window.innerWidth < SOGLIA) {
      if (g.striscia) g.griglia.classList.add('hh-hall-strip');
      g.celle.forEach(function (c, i) { if (i >= g.quante) c.classList.add('is-hall-hidden'); });
    }

    pannello.removeAttribute('data-theme');
    pannello.classList.remove('is-open');
    document.body.classList.remove('hh-hall-open');
    var spegni = function () { if (!aperta) pannello.hidden = true; };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) spegni();
    else {
      setTimeout(spegni, 240);
      /* seconda passata: su WebKit la prima puo' cadere in mezzo a un cambio
         di cronologia e il pannello resta aperto. Spegnere due volte non fa
         danno, restare aperti si' */
      setTimeout(spegni, 900);
    }

    g.bottone.setAttribute('aria-expanded', 'false');
    window.scrollTo(0, scrollPrima);
    if (fuocoPrima && fuocoPrima.focus) fuocoPrima.focus();

    if (gestisciStoria) {
      try { if (history.state && history.state.hh_hall) history.back(); } catch (e) { /* pazienza */ }
    }
  }

  /* ---------- una galleria ---------- */
  function prepara(griglia) {
    var celle = [].slice.call(griglia.children);
    if (celle.length < 3) return null;

    var sezione = griglia.closest('.hh-section, section') || griglia.parentNode;
    var h2 = sezione.querySelector('h2');
    /* Quante ne stanno nella striscia prima dell'invito ad aprire. Se il numero
       scritto nel pannello copre gia' tutta la galleria si lascia fuori
       qualcosa: l'invito deve avere qualcosa da promettere. */
    var quante = parseInt(griglia.getAttribute('data-hh-hall-preview'), 10);
    if (!(quante > 0)) quante = 6;
    if (quante >= celle.length) quante = Math.max(2, celle.length - 2);

    var g = {
      griglia: griglia,
      celle: celle,
      quante: quante,
      /* Un elenco di parole non si corica: una fila orizzontale di righe di
         testo non si legge. Li' si taglia e basta, e il resto sta nella sala. */
      striscia: griglia.getAttribute('data-hh-hall-strip') !== 'no',
      nome: testo(griglia, 'data-hh-hall', h2 ? h2.textContent.trim() : ''),
      conto: testo(griglia, 'data-hh-hall-count', celle.length + ' in all'),
      /* Il tema della sezione viene con la galleria. Il bestiario e' a
         inchiostro e i suoi testi sono color osso: portati su una stanza di
         carta chiara sparivano. Misurato guardando lo scatto, non a occhio. */
      tema: (sezione.getAttribute('data-theme') ||
             (sezione.closest('[data-theme]') ? sezione.closest('[data-theme]').getAttribute('data-theme') : '')),
      segnaposto: document.createComment('hh-hall'),
      bottone: null
    };

    /* Sul telefono si tocca la figura, non la scritta sotto. Dove il comando
       che apre e' un elemento a parte (i libri: la copertina e' un'immagine, il
       comando e' il bottone "Read a page"), la figura inoltra il tocco al
       comando. Cosi' il bersaglio e' grande quanto la copertina, e chi usa la
       tastiera continua a trovare il bottone vero. */
    celle.forEach(function (c) {
      var comando = c.querySelector('[data-hh-pages], button, a[href]');
      var figura = c.querySelector('img');
      if (!comando || !figura || comando.contains(figura)) return;
      figura.style.cursor = 'pointer';
      figura.addEventListener('click', function () { comando.click(); });
    });

    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'hh-btn hh-btn--secondary hh-hall__open';
    b.setAttribute('aria-expanded', 'false');
    b.innerHTML = '<span class="hh-hall__open-text">' +
      testo(griglia, 'data-hh-hall-cta', 'Open all') + '</span>' +
      '<span class="hh-hall__open-rest">' + g.conto + '</span>';
    b.addEventListener('click', function () { apri(g); });

    griglia.parentNode.insertBefore(g.segnaposto, griglia.nextSibling);
    griglia.parentNode.insertBefore(b, g.segnaposto.nextSibling);
    g.bottone = b;
    return g;
  }

  /* ---------- quanto si vede, secondo la larghezza ---------- */
  function adatta() {
    var stretto = window.innerWidth < SOGLIA;
    gallerie.forEach(function (g) {
      if (aperta === g) return;
      g.bottone.hidden = !stretto;
      g.griglia.classList.toggle('hh-hall-strip', stretto && g.striscia);
      g.celle.forEach(function (c, i) {
        c.classList.toggle('is-hall-hidden', stretto && i >= g.quante);
      });
    });
    if (aperta && !stretto) chiudi(true);
  }

  /* ---------- avvio ---------- */
  function avvia() {
    document.querySelectorAll('[data-hh-hall]').forEach(function (griglia) {
      var g = prepara(griglia);
      if (g) gallerie.push(g);
    });
    if (!gallerie.length) return;
    adatta();

    var tempo = null;
    window.addEventListener('resize', function () {
      clearTimeout(tempo);
      tempo = setTimeout(adatta, 150);
    }, { passive: true });

    /* In cattura, non in risalita: chi chiude la foto (hh-fx, hh-books) ha
       il suo ascoltatore sul documento, e se parla per primo quando arriva
       il nostro turno la foto risulta gia' chiusa. Allora Esc chiuderebbe
       la foto E la sala in un colpo solo: misurato sulle tavole. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !aperta) return;
      /* se sopra la sala c'e' una foto aperta, Esc chiude quella: la sala
         resta, che e' il passo indietro che si aspetta chi guarda */
      if (fotoAperta()) return;
      chiudi(true);
    }, true);

    window.addEventListener('popstate', function () {
      if (!aperta) return;
      var f = fotoAperta();
      if (f) {
        chiudiFoto(f);
        try { history.pushState({ hh_hall: 1 }, ''); } catch (e) {}
        return;
      }
      chiudi(false);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})();
